import { render } from "./MagnifyingGlass.vue?vue&type=template&id=78a0a53d&scoped=true"
import script from "./MagnifyingGlass.vue?vue&type=script&setup=true&lang=js"
export * from "./MagnifyingGlass.vue?vue&type=script&setup=true&lang=js"

import "./MagnifyingGlass.vue?vue&type=style&index=0&id=78a0a53d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a0a53d"],['__file',"src/icons/MagnifyingGlass.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78a0a53d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78a0a53d', __exports__)) {
    api.reload('78a0a53d', __exports__)
  }
  
  module.hot.accept("./MagnifyingGlass.vue?vue&type=template&id=78a0a53d&scoped=true", () => {
    api.rerender('78a0a53d', render)
  })

}


export default __exports__